import React from 'react';
import {Text, TextTypography} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {classes} from './NoPremiumMessage.st.css';
import CloseIcon from './CloseIcon.svg';

export enum NoPremiumMessageDataHooks {
  Root = 'NoPremiumMessageDataHooks.Root',
  CloseIcon = 'NoPremiumMessageDataHooks.CloseIcon',
  Title = 'NoPremiumMessageDataHooks.Title',
  Message = 'NoPremiumMessageDataHooks.Message',
}

export const NoPremiumMessage = () => {
  return (
    <div data-hook={NoPremiumMessageDataHooks.Root} className={classes.root}>
      <div data-hook={NoPremiumMessageDataHooks.CloseIcon} className={classes.closeIcon}>
        <CloseIcon />
      </div>
      <Text data-hook={NoPremiumMessageDataHooks.Title} typography={TextTypography.largeTitle}>
        {useLocaleKeys().checkout.noPremiumMerchant.checkoutUnavailable.title()}
      </Text>
      <Text data-hook={NoPremiumMessageDataHooks.Message} typography={TextTypography.runningText}>
        {useLocaleKeys().checkout.noPremiumMerchant.checkoutUnavailable.body()}
      </Text>
    </div>
  );
};
